import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { ORDENES } from "../Constants/Endpoinst";

const DISPONIBILIDAD_ENDPOINT = ORDENES.disponibilidad;

export const getDisponibilidadOrden = async (orden) => {
    const urlConQuery = `${DISPONIBILIDAD_ENDPOINT}?orden=${encodeURIComponent(orden)}`;
    const { code, data } = await ApiRequestInterceptorQS(urlConQuery, "GET");

    return { code, data };
};
